import { applyNonceToElement } from 'core/utils/csp-nonce';

export function appendPricelessSDKScript() {
  const pricelessSdkScript = document.getElementById('priceless-sdk-script');
  if (pricelessSdkScript) {
    document.head.removeChild(pricelessSdkScript);
  }

  const script = document.createElement('script');
  script.id = 'priceless-sdk-script';
  script.src = 'https://donate.mastercard.com/widget/p2/assets/sdk/donate-widget.min.js';
  script.defer = true;
  script.async = true;
  applyNonceToElement(script);
  document.head.appendChild(script);
}

export function appendPricelessScript(options: string) {
  const pricelessScript = document.getElementById('priceless-script');

  if (pricelessScript) {
    document.head.removeChild(pricelessScript);
  }

  const script = document.createElement('script');
  script.id = 'priceless-script';
  applyNonceToElement(script);

  script.innerHTML = `(function(window, document){
    window.loadWidgetSDK = function() {
      const widget = new (window).DonateWidget();
      widget.launchLightbox(${options});
    };

    const ze_button = document.querySelector('#ze_button');
    if(ze_button){
      ze_button.addEventListener('click', function(e){
        e.preventDefault();
        loadWidgetSDK();
      }, false);
    }

  })(window, document);`;

  document.head.appendChild(script);
}
